import type { EmailLookupData } from '@/core/models/auth';
import * as localStorage from './local-storage';

export const EMAIL_ADDRESS_LOCAL_STORAGE_KEY = 'mindoasis:emailAddress';
export const EMAIL_LOOKUP_DATA_LOCAL_STORAGE_KEY = 'mindoasis:emailLookupData';

export function setEmailAddressLocally(emailAddress: string | null) {
  localStorage.setItem(EMAIL_ADDRESS_LOCAL_STORAGE_KEY, emailAddress);
}

export function getLocalEmailAddress() {
  return localStorage.getItem<string | null>(EMAIL_ADDRESS_LOCAL_STORAGE_KEY);
}

export function setEmailLookupDataLocally(emailLookupData: EmailLookupData | null) {
  localStorage.setItem(EMAIL_LOOKUP_DATA_LOCAL_STORAGE_KEY, emailLookupData);
}

export function getLocalEmailLookupData(): EmailLookupData | null {
  return localStorage.getItem<EmailLookupData | null>(EMAIL_LOOKUP_DATA_LOCAL_STORAGE_KEY);
}
